export const CREATE_ARCHITECTURECAREPLAN = "CREATE_ARCHITECTURECAREPLAN";   
export const RETRIEVE_ARCHITECTURECAREPLAN = "RETRIEVE_ARCHITECTURECAREPLAN";
export const RETRIEVESINGLE_ARCHITECTURECAREPLAN = "RETRIEVESINGLE_ARCHITECTURECAREPLAN";
export const UPDATE_ARCHITECTURECAREPLAN = "UPDATE_ARCHITECTURECAREPLAN";   
export const DELETE_ARCHITECTURECAREPLAN = "DELETE_ARCHITECTURECAREPLAN";   
